(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true; // Always keep header visible
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateTransparentHeaderState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    // The transparent (home) header paints no background of its own, so it has
    // to gain one once content scrolls under it — otherwise the nav sits as
    // white-on-whatever-is-behind-it. Nothing was toggling this class on scroll:
    // only details-disclosure.js set it, for the mega panel. Because that shares
    // the class, release it only when no panel is open, or scrolling back to the
    // top while hovering the menu would strip the panel's own backdrop.
    updateTransparentHeaderState(scrollTop) {
      const wrapper = this.header.querySelector('.header-wrapper--transparent');
      if (!wrapper) return;

      if (scrollTop > 4) {
        wrapper.classList.add('header-scrolled');
      } else if (!wrapper.querySelector('.mega-menu[open]')) {
        wrapper.classList.remove('header-scrolled');
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent Header Class
  class TransparentHeader {
    constructor() {
      this.headerWrapper = document.querySelector('.header-wrapper--transparent');
      if (!this.headerWrapper) return;

      this.currentScrollTop = 0;
      this.ticking = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateHeader();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateHeader() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 50) {
        // Scrolled - show background
        this.headerWrapper.classList.add('header-scrolled');
      } else {
        // At top - transparent
        this.headerWrapper.classList.remove('header-scrolled');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  // Initialize transparent header if it exists
  document.addEventListener('DOMContentLoaded', () => {
    new TransparentHeader();
  });

  // Handle header group z-index when drawer opens/closes
  const drawerContainer = document.getElementById('Details-menu-drawer-container');
  const headerGroups = document.querySelectorAll('.shopify-section-group-header-group');

  if (drawerContainer && headerGroups.length > 0) {
    drawerContainer.addEventListener('toggle', function () {
      if (this.open) {
        // Drawer is opening - lower header group z-index
        headerGroups.forEach((group) => {
          group.style.zIndex = '3';
        });
      } else {
        // Drawer is closing - restore original z-index
        headerGroups.forEach((group) => {
          group.style.zIndex = '';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
